import { useLocation, useNavigate } from 'react-router-dom'
import { clearStorageCache } from 'src/storage'
import { getEnvString } from 'src/utils'
import { useGetTokenForCode } from './queries'

type Props = {
  currentState?: string
}

export function useAuth(props?: Props) {
  const navigate = useNavigate()
  const location = useLocation()
  const getTokenForCode = useGetTokenForCode()

  const defaultState = location.pathname + location.search

  return {
    isLoading: getTokenForCode.isLoading,
    login: () => {
      window.location.href =
        getEnvString('REACT_APP_AMAZON_LOGIN') +
        new URLSearchParams({
          client_id: getEnvString('REACT_APP_IDEAL_CLIENT_ID'),
          response_type: 'code',
          scope: 'openid phone profile',
          redirect_uri: window.location.origin,
          state: props?.currentState || defaultState,
        })
    },
    logout: () => {
      sessionStorage.clear()
      clearStorageCache('ALL')
      navigate('/')
    },
  }
}
